// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';

const $ = require('jquery');

/** Populate Router instance with DOM routes */
const rebootRoutes = new Router({
  // Home page
  home,
  // All pages
  common,
});

// Load Events
$(() => rebootRoutes.loadEvents());

